import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Image, Row, Col } from 'antd';
import { EnhancedMarkdown } from 'common/components';
import { useResize } from 'hooks/useResize';
import { Images } from 'config/assets';
import { OverlayValueItem } from 'common/components/overlay';
import { useCheckIsProductOverlay } from 'hooks/product';

const markdownContentId = 'pim-description-markdown-content';

const ProductOverviewContent = ({
  product,
  originProduct,
  heightContainer,
  heightPrimaryInfo,
  ...rest
}) => {
  const wrapperSize = useResize(markdownContentId);
  const isOverlay = useCheckIsProductOverlay();
  const showOverlay = !!originProduct && isOverlay;

  const overviewText = useMemo(() => {
    return getOverviewText(product);
  }, [JSON.stringify(product)]);

  const renderImageOverview = () => {
    return product?.productMarketingImage || Images.RIVIR_LOGO_DEFAULT; // first image of additional
  };

  return (
    <div
      className='product-overview__content scroller scroller--y'
      style={{
        height: `calc(100vh - (164px + ${heightContainer || 0}px + ${
          heightPrimaryInfo || 0
        }px))`,
      }}
    >
      <Row>
        <Col span={12}>
          <OverlayValueItem
            originValue={getOverviewText(originProduct) || 'N/A'}
            showOverlay={
              getOverviewText(originProduct) !== getOverviewText(product) &&
              showOverlay
            }
          >
            <EnhancedMarkdown
              source={overviewText}
              containerSize={wrapperSize}
            />
          </OverlayValueItem>
        </Col>

        <Col span={12} style={{ textAlign: 'center' }}>
          <Image
            className='product-overview__content-marketing-image'
            src={renderImageOverview()}
            preview={false}
          />
        </Col>
      </Row>
    </div>
  );
};

const getOverviewText = (product) => {
  return (
    product?.rivirMarketingDescription ||
    product?.eCommerceProductDescription ||
    product?.eCommerceLongDescriptionA ||
    product?.eCommerceLongDescriptionB ||
    product?.eCommerceShelfDescription ||
    product?.formatFoodServiceProductDescription ||
    ''
  );
};

ProductOverviewContent.propTypes = {
  product: PropTypes.object,
};

export default ProductOverviewContent;
